module.exports = __webpack_public_path__ + "static/media/dk1050.bd87ca7c.png";